import { Image } from './Image.styles'

interface IComponentImage {
  src: string
  height?: string
  width?: string
  objectFit?: string
}

const ComponentImage = ({
  width = '100%',
  height = '100%',
  src,
  objectFit = 'fill'
}: IComponentImage) => {
  const allProps = { height, objectFit, src, width }
  return <Image {...allProps} />
}

export default ComponentImage
